jQuery(document).ready(function() {
  jQuery('.logo-slider').slick({
    dots: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    easing: "linear",
    adaptiveHeight: false,
    centerMode: true,
    centerPadding: '60px',
    touchThreshold:'1000',
    variableWidth: true
  });
  jQuery('.logo-slider-3').slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    easing: "linear",
    adaptiveHeight: false,
    centerMode: true,
    centerPadding: '60px',
    touchThreshold:'1000',
    variableWidth: true
  });
  jQuery('.logo-slider-4').slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    easing: "linear",
    adaptiveHeight: false,
    centerMode: true,
    centerPadding: '60px',
    touchThreshold:'1000',
    variableWidth: true
  });
  jQuery('.logo-slider-5').slick({
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    easing: "linear",
    adaptiveHeight: false,
    centerMode: true,
    centerPadding: '60px',
    touchThreshold:'1000',
    variableWidth: true
  });
  jQuery('.logo-slider-6').slick({
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    easing: "linear",
    adaptiveHeight: false,
    centerMode: true,
    centerPadding: '60px',
    touchThreshold:'1000',
    variableWidth: true
  });
  jQuery('.logo-slider-7').slick({
    dots: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    easing: "linear",
    adaptiveHeight: false,
    centerMode: true,
    centerPadding: '60px',
    touchThreshold:'1000',
    variableWidth: true
  });
  setHeaderTop();
  $(window).on('resize', debounce(setHeaderTop, 150));

});

function debounce(func, wait = 100) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function setHeaderTop() {
  if ($('.announcement-bar').length) {
    var barHeight = $('.announcement-bar').outerHeight();
    $('#header').css('top', barHeight + 'px');
    $('#MainContent').css('paddding-top', barHeight + 'px');
  }
}
function handleAnnouncementBarScroll() {
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');
  
  if (!announcementBar) return;
  
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const barHeight = announcementBar.offsetHeight;
  
  if (scrollTop > 50) {
    announcementBar.style.transform = `translateY(-${barHeight}px)`;
  } else {
    announcementBar.style.transform = 'translateY(0)';
  }
}

window.addEventListener('scroll', debounce(handleAnnouncementBarScroll, 10));
window.addEventListener('DOMContentLoaded', handleAnnouncementBarScroll);